import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jacobhaas.website";

interface SeoProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  jsonLd?: Record<string, unknown>;
}

const Seo = ({ title, description, path, noindex, jsonLd }: SeoProps) => {
  const url = `${SITE_URL}${path}`;

  // The static index.html head ships fallback tags for social crawlers.
  // Remove those duplicates on the client so each route has a single set.
  useEffect(() => {
    const selectors = [
      'meta[name="description"]',
      'meta[property="og:description"]',
      'meta[property="og:title"]',
      'meta[property="og:url"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]',
      "link[rel=\"canonical\"]",
    ];
    selectors.forEach((selector) => {
      document
        .head
        .querySelectorAll(selector)
        .forEach((el) => {
          if (!el.hasAttribute("data-rh")) el.remove();
        });
    });
  });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
